import { offerChange } from "./offer";
import { personalDataFormValidateAndSubmit } from "./personalDataForm";

const defaultState = {
    isPopupOpen: false,
    offerTypeSelected: null,

    isApiRequesting: false,
    isApiError: false,
    isApiSuccess: false,
}

const SET_POPUP_OPEN = 'SET_POPUP_OPEN';
export const changeOfferTypeSetPopupOpen = isOpen => ({
    type: SET_POPUP_OPEN, isOpen
});

const SELECT_OFFER_TYPE = 'SELECT_OFFER_TYPE';
export const changeOfferSelectType = offerType => ({
    type: SELECT_OFFER_TYPE, offerType
});

const CHANGE_OFFER_RESET_STATE = 'CHANGE_OFFER_RESET_STATE';
export const changeOfferResetState = () => ({ type: CHANGE_OFFER_RESET_STATE });

const CHANGE_OFFER_START_REQUEST = 'CHANGE_OFFER_START_REQUEST';
const changeOfferStartRequest = () => ({ type: CHANGE_OFFER_START_REQUEST });

const CHANGE_OFFER_ERROR_REQUEST = 'CHANGE_OFFER_ERROR_REQUEST';
const changeOfferErrorRequest = () => ({ type: CHANGE_OFFER_ERROR_REQUEST });

const CHANGE_OFFER_SUCCESS_REQUEST = 'CHANGE_OFFER_SUCCESS_REQUEST';
const changeOfferSuccessRequest = () => ({ type: CHANGE_OFFER_SUCCESS_REQUEST });

export const confirmChangeType = () => async (dispatch, getState) => {
    const { changeOfferTypeState, globalFormFieldsReducer } = getState();
    const otp = globalFormFieldsReducer.otp;
    dispatch(offerChange(changeOfferTypeState.offerTypeSelected));

    if (otp) {
        try {
            console.log('Updating offer');
            dispatch(changeOfferStartRequest());
            await dispatch(personalDataFormValidateAndSubmit(false));
            dispatch(changeOfferSuccessRequest());
            dispatch(changeOfferResetState());
        } catch (error) {
            console.log(error);
            dispatch(changeOfferErrorRequest());
        }
    } else {
        dispatch(changeOfferResetState());
    }
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case SET_POPUP_OPEN: return { ...state, isPopupOpen: action.isOpen }
        case SELECT_OFFER_TYPE: return { ...state, offerTypeSelected: action.offerType }
        case CHANGE_OFFER_START_REQUEST: return { 
            ...state, 
            isApiRequesting: true, 
            isApiError: false, 
            isApiSuccess: false 
        }
        case CHANGE_OFFER_ERROR_REQUEST: return {
            ...state,
            isApiRequesting: false,
            isApiError: true,
            isApiSuccess: false,
        }
        case CHANGE_OFFER_SUCCESS_REQUEST: return {
            ...state,
            isApiRequesting: false,
            isApiError: false,
            isApiSuccess: true,
        }
        case CHANGE_OFFER_RESET_STATE: return { ...defaultState, isPopupOpen: false }
        default: {
            return state;
        }
    }
}